// extracted by mini-css-extract-plugin
export default {"button":"AsttButton_button__XVjsk"};